import PropTypes from 'prop-types';
import React from 'react';
import { Col, Drawer } from 'antd';
import DynamicRemindersField from './reminder/DynamicRemindersField';
import { formSectionsPropType } from '../forms/forms.propTypes';

export default function ScheduleReminderDrawer({
  form,
  isDisplay,
  visible,
  onClose,
  selectedDivisionId,
  selectedProjectId,
  isFormConfig,
  sections,
}) {
  return (
    <Drawer
      width={800}
      visible={visible}
      onClose={onClose}
      title="Reminders"
      maskClosable={false}
      forceRender
    >
      <Col>
        <DynamicRemindersField
          type="reminders"
          isDisplay={isDisplay}
          visible={visible}
          isFormConfig={isFormConfig}
        />
        <DynamicRemindersField
          form={form}
          type="externalReminders"
          isDisplay={isDisplay}
          selectedDivisionId={selectedDivisionId}
          selectedProjectId={selectedProjectId}
          visible={visible}
          isFormConfig={isFormConfig}
          sections={sections}
        />
      </Col>
    </Drawer>
  );
}

ScheduleReminderDrawer.propTypes = {
  isDisplay: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  selectedDivisionId: PropTypes.string,
  selectedProjectId: PropTypes.string,
  form: PropTypes.shape({}),
  isFormConfig: PropTypes.bool,
  sections: formSectionsPropType,
};

ScheduleReminderDrawer.defaultProps = {
  isDisplay: false,
  visible: false,
  selectedDivisionId: undefined,
  selectedProjectId: undefined,
  form: undefined,
  isFormConfig: false,
  sections: [],
};
